import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  buttonDelete: {
    marginBottom: 10,
    color: "#ffffff",
    backgroundColor: theme.palette.secondary.dark
  },
}));